import { formatCalls } from './nodeChartTheme';

/**
 * Значения, скрытые тенантом с графика («Настройки» → «Узлы анализа» → «Подписи и показ
 * значений»).
 *
 * Строки и знаменатель агрегата сервер уже пересчитал: скрытых кодов в ответе нет, а звонки
 * с одними скрытыми значениями вычтены из «применимых». Клиенту остаются две вещи, которые
 * сервер за него сделать не может, — объявленные значения карточки и строка шапки.
 */

/**
 * Объявленные значения карточки без скрытых. Каталог отдаёт скрытые в `options` (они нужны
 * настройкам и фильтрам), и без этого шага `fill_declared` вернул бы скрытый код нулевой
 * строкой, а кольцо — пустым сегментом легенды.
 */
export const visibleDeclaredOptions = (chart) => {
  // Объявленные значения лежат в `options` у категорий и в `items` у чек-листов. Проверяем
  // именно на непустоту, а не через `??`: каталог отдаёт `[]`, а не null, и `options ?? items`
  // всегда возвращал бы пустой массив — объявленный порядок пунктов чек-листа тихо терялся.
  const declared = chart?.options?.length ? chart.options : (chart?.items ?? []);
  const hidden = new Set(chart?.hiddenValues ?? []);

  return hidden.size === 0 ? declared : declared.filter((option) => !hidden.has(option.code));
};

/**
 * Строка под заголовком карточки. У чек-листа знаменатель — оценённые звонки, у остальных —
 * применимые. Звонки, выпавшие из-за скрытых значений, называются отдельно: иначе число
 * «применимых» молча расходилось бы с соседними карточками той же ноды.
 */
export const describeChartMeta = ({ isChecklist, denominator = 0, skipped = 0, hiddenCalls = 0, packVersions = [] }) => {
  const parts = [];

  if (isChecklist) {
    parts.push(denominator > 0 ? `Оценено звонков: ${formatCalls(denominator)}` : 'Нет данных за выбранный период');

    if (skipped > 0) {
      parts.push(`не применим: ${formatCalls(skipped)}`);
    }
  } else {
    if (denominator > 0) {
      parts.push(`Применимых звонков: ${formatCalls(denominator)}`);
    } else {
      parts.push(hiddenCalls > 0 ? 'Нет звонков с показанными значениями' : 'Нет данных за выбранный период');
    }

    if (hiddenCalls > 0) {
      parts.push(`скрыто значениями: ${formatCalls(hiddenCalls)}`);
    }

    if (skipped > 0) {
      parts.push(`пропущено по фильтру: ${formatCalls(skipped)}`);
    }
  }

  // Историю могли посчитать несколькими наборами нод. Выдачу по версии мы не режем — иначе
  // смена набора обнуляла бы накопленную статистику, — но сказать об этом надо: у выхода могли
  // смениться объявленные значения, и на графике будут коды обеих версий.
  if (packVersions.length > 1) {
    parts.push(`версии пакета: ${packVersions[0]}–${packVersions[packVersions.length - 1]}`);
  }

  return parts.join(' · ');
};
